import CommonLandingContainer from 'src/components/landingComponents/containers/common';
import styles from './popular.module.scss';
import {
  Heading2,
  SecondaryText,
  Button,
  Heading3,
} from 'src/components/landingComponents/typography';
import bubbles from 'src/assets/img/landing/bubbles.png';
import sphere from 'src/assets/img/landing/waterSphere.png';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import InfoPanel from 'src/components/landingComponents/containers/infoPanel';
import { getClassName } from 'src/Core/utility/jsx';
import LandingButton from 'src/components/landingComponents/button';
import { useNavigate } from 'react-router-dom';

const PopularTests = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <Heading2 className={styles.title} accent>
        Самые популярные тесты
      </Heading2>
      <div className={styles.blocks}>
        <Left />
        <Middle />
        <Right />
      </div>
    </CommonLandingContainer>
  );
};

export default PopularTests;

const Left = () => {
  return (
    <AnimatedBox className={getClassName([styles.left, styles.square])}>
      <img
        fetchpriority="low"
        className={styles.bubbles}
        src={bubbles}
        alt=""
      />
      <div className={styles.bubbleTitle}>
        <Heading3 accent>{`Общий 
        анализ
         крови`}</Heading3>
      </div>
    </AnimatedBox>
  );
};

const Middle = () => {
  const navigate = useNavigate();

  return (
    <AnimatedBox className={getClassName([styles.square])} delay={0.2}>
      <div className={styles.middle}>
        <InfoPanel
          sparse
          Header={() => (
            <Heading3 accent className={styles.middleSquareHeader}>
              Биохимический анализ крови
            </Heading3>
          )}
        >
          <SecondaryText>
            Этот анализ дает важную информацию о состоянии вашего обмена веществ
            и помогает своевременно обнаружить возможные нарушения в работе
            внутренних органов
          </SecondaryText>
        </InfoPanel>
        <div>
          <LandingButton variant="contained" href="/about?show=oak">
            <Button>Подробнее</Button>
          </LandingButton>
        </div>
      </div>
    </AnimatedBox>
  );
};

const Right = () => {
  return (
    <AnimatedBox
      className={getClassName([styles.right, styles.square])}
      delay={0.4}
    >
      <div className={styles.rightContainer}>
        <img
          fetchpriority="low"
          className={styles.bubbles}
          src={sphere}
          alt=""
        />
        <div className={styles.bubbleTitle}>
          <Heading3 accent>{`Другие
           популярные
            тесты`}</Heading3>
        </div>
        {/* <div className={styles.ellipsBlur}></div> */}
      </div>
    </AnimatedBox>
  );
};
